export const COMMON_CLOSE = 'Close';
export const COMMON_DONT_SHOW = 'Don’t show again';

export const TRANSLATIONS_GO_TO_SETTINGS = 'Go to translation settings';
